"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _propTypes = _interopRequireDefault(require("prop-types"));

var SEO = function SEO(_ref) {
  var businessName = _ref.businessName,
      pageName = _ref.pageName,
      description = _ref.description,
      images = _ref.images;
  var seo = {
    title: "".concat(pageName, " | ").concat(businessName),
    description: description,
    image: images && images.length ? images[0] : null
  };
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, {
    title: seo.title
  }, seo.description && /*#__PURE__*/_react["default"].createElement("meta", {
    name: "description",
    content: seo.description
  }), seo.image && /*#__PURE__*/_react["default"].createElement("meta", {
    name: "image",
    content: seo.image
  }));
};

var _default = SEO;
exports["default"] = _default;
SEO.propTypes = {
  businessName: _propTypes["default"].string.isRequired,
  pageName: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  images: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
SEO.defaultProps = {
  images: []
};